import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgahFooterLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='66'
    height='27'
    viewBox='0 0 66 27'
    fill='none'
    {...props}
  >
    <path
      d='M3.96617 10.007C3.95845 8.39933 4.59276 6.85448 5.72955 5.71228C6.86634 4.57007 8.41249 3.92407 10.0279 3.91639C11.6433 3.90871 13.1955 4.53998 14.3433 5.67132C15.491 6.80266 16.1401 8.3414 16.1478 9.94904H20.0975C20.0864 7.80789 19.385 5.72681 18.0967 4.01198C16.8083 2.29716 15.0009 1.03913 12.9404 0.422991C10.8799 -0.193148 8.67511 -0.134866 6.65039 0.589262C4.62566 1.31339 2.88793 2.66513 1.69284 4.4456C0.497757 6.22608 -0.0915739 8.34127 0.0115555 10.48C0.114685 12.6187 0.904829 14.668 2.26574 16.3264C3.62665 17.9848 5.48646 19.1648 7.57155 19.6926C9.65665 20.2204 11.8569 20.0684 13.8487 19.2587L12.3665 15.6155C11.4415 15.9927 10.4374 16.1376 9.44286 16.0373C8.4483 15.937 7.49384 15.5946 6.66369 15.0403C5.83354 14.4861 5.15324 13.737 4.68279 12.8592C4.21235 11.9814 3.96624 11.0018 3.96617 10.007Z'
      fill='#0F1017'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />

    <path
      d='M10.0508 9.94824L12.3665 15.6168C13.4848 15.1607 14.4415 14.3839 15.1148 13.3852C15.7882 12.3865 16.1477 11.211 16.1478 10.0082V9.94824H10.0508Z'
      fill='rgb(var(--blue-1))'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />

    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M37.9247 16.0808V20.0529H51.7049C51.7722 20.0529 51.8367 20.0795 51.8843 20.1269C51.9318 20.1742 51.9585 20.2384 51.9585 20.3053V22.0866L45.3065 22.0742C43.1882 22.0742 37.4674 22.0742 36.1952 22.0866C36.1279 22.0866 36.0634 22.06 36.0159 22.0127C35.9683 21.9653 35.9416 21.9011 35.9416 21.8342L35.9166 11.9556C35.9166 11.4239 35.9291 10.1847 35.9291 10.0937H31.4473V14.1279L31.9441 14.612V24.1099C31.9441 24.6187 32.1471 25.1067 32.5084 25.4667C32.8697 25.8267 33.3598 26.0292 33.8711 26.0297H55.9685C55.9872 24.263 55.9685 22.4838 55.9685 20.715C55.9685 19.9185 55.9685 18.8779 55.9685 17.98C55.9693 17.7277 55.9201 17.4778 55.8236 17.2445C55.7271 17.0112 55.5852 16.7992 55.4062 16.6206C55.2271 16.4421 55.0144 16.3004 54.7802 16.2039C54.546 16.1074 54.295 16.0578 54.0415 16.0581H43.9324C43.9324 16.0581 43.9324 16.0581 43.9324 16.0457L54.1475 10.0896V10.0771H48.1918L37.9247 16.0808Z'
      fill='#0F1017'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />

    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M21.9247 18.138H25.9367V21.8618C25.9368 21.929 25.9101 21.9934 25.8626 22.041C25.8151 22.0887 25.7506 22.1158 25.6831 22.1163H21.933V18.1421H17.9355V26.0719H27.9989C28.5098 26.0708 28.9994 25.868 29.3603 25.5081C29.7212 25.1482 29.9238 24.6605 29.9238 24.152V14.1162H21.9268L21.9247 18.138Z'
      fill='#0F1017'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />

    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M53.9443 15.5551H57.9481V14.0863H64.0326C64.286 14.0865 64.537 14.0371 64.7712 13.9407C65.0054 13.8443 65.2181 13.7029 65.3973 13.5246C65.5765 13.3462 65.7186 13.1345 65.8154 12.9014C65.9123 12.6684 65.962 12.4186 65.9617 12.1664V10.1162H55.8838C55.3725 10.1173 54.8825 10.3199 54.521 10.6797C54.1594 11.0395 53.9558 11.5272 53.9547 12.0361L53.9443 15.5551Z'
      fill='#0F1017'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />

    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M57.9512 26.0943H60.0299C60.5421 26.0943 61.0333 25.8918 61.3955 25.5314C61.7577 25.171 61.9611 24.6821 61.9611 24.1724V16.0875C61.9611 16.0875 58.7889 16.073 57.9657 16.0875L57.9512 26.0943Z'
      fill='#0F1017'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />

    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M37.9248 13.1885V15.4786L47.2128 10.0997L43.2652 10.0977L37.9248 13.1885Z'
      fill='#0F1017'
      stroke='#CE2E3B'
      stroke-width='1.5'
    />
  </svg>
);
export default SvgAgahFooterLogo;
